var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g4, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g5, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g6, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g7, _path65, _path66, _path67, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperCoinStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 46,
    viewBox: "0 0 65 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "400 coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.9037 31.8171C47.9327 28.2464 41.5527 25.2916 33.6537 25.2174C25.7547 25.1431 19.3278 27.9776 19.2989 31.5483C19.2699 35.119 25.6499 38.0739 33.5489 38.1481C41.4479 38.2223 47.8748 35.3879 47.9037 31.8171Z",
    fill: "#FF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.9382 26.9864L19.3521 26.7178L19.3114 31.7292L47.8976 31.9979L47.9382 26.9864Z",
    fill: "#FF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.2904 26.7207L19.2515 31.5941C19.2515 31.5941 19.0783 34.5771 24.5594 36.6279L24.7773 31.3881C24.7773 31.3881 20.18 29.5755 19.2907 26.721L19.2904 26.7207Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 29,
    height: 14
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.8578 31.8537C47.8876 28.283 41.5084 25.3301 33.6094 25.2582C25.7103 25.1862 19.2827 28.0225 19.2528 31.5933C19.2229 35.164 25.6022 38.1169 33.5012 38.1888C41.4003 38.2608 47.8279 35.4244 47.8578 31.8537Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6048 28.0735L32.2515 28.042L32.1599 39.3434L35.5133 39.3749L35.6048 28.0735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7263 27.9923L36.8206 27.918L36.729 39.2194L44.6347 39.2937L44.7263 27.9923Z",
    fill: "white"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.9337 26.9863C47.9613 23.5833 41.5714 20.7643 33.6616 20.69C25.7517 20.6157 19.3171 23.3141 19.2896 26.7171C19.262 30.1202 25.6518 32.9392 33.5617 33.0135C41.4716 33.0878 47.9061 30.3894 47.9337 26.9863Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M33.6677 32.719C25.8487 32.6451 19.5154 29.8892 19.3976 26.5391C19.3934 26.597 19.391 26.6552 19.3903 26.7138C19.3625 30.117 25.7523 32.9363 33.6622 33.0108C41.5722 33.0857 48.0069 30.3874 48.0344 26.9846C48.0347 26.9455 48.0338 26.9065 48.0326 26.8674C47.7906 30.1876 41.4416 32.7925 33.6677 32.719Z",
    fill: "url(#paint0_linear_3418_365219)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.6731 26.6128C43.6907 24.439 39.216 22.6346 33.6787 22.5825C28.1413 22.5305 23.6381 24.2505 23.6205 26.4243C23.6029 28.5981 28.0775 30.4025 33.6149 30.4546C39.1523 30.5066 43.6555 28.7866 43.6731 26.6128Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M33.6497 22.574C39.045 22.6251 43.4307 24.3397 43.6356 26.4382C43.6419 26.3832 43.6462 26.3279 43.6465 26.2719C43.6643 24.0982 39.1897 22.2938 33.6525 22.2414C28.1152 22.189 23.6119 23.9088 23.5941 26.0826C23.5935 26.1382 23.5968 26.1939 23.6022 26.2488C23.8415 24.1545 28.2542 22.5229 33.6497 22.574Z",
    fill: "url(#paint1_linear_3418_365219)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.7133 23.138C38.8786 23.1868 43.1184 24.7605 43.6505 26.7361C43.6539 26.6957 43.6563 26.6554 43.6566 26.6147C43.6744 24.441 39.1999 22.6366 33.6626 22.5842C28.1253 22.5318 23.622 24.2516 23.6042 26.4253C23.603 26.5714 23.6226 26.7156 23.661 26.8581C23.8417 24.7423 28.2794 23.0869 33.713 23.1384L33.7133 23.138Z",
    fill: "#CB6300"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M32.4973 23.8174L30.2044 23.8076L30.1975 25.6996L32.4904 25.7093L32.4973 23.8174ZM32.4973 23.8174L30.2044 23.8076L30.1975 25.6996L32.4904 25.7093L32.4973 23.8174ZM32.4834 27.6022L30.1905 27.5925L30.1836 29.4844L32.4765 29.4942L32.4834 27.6022ZM32.4834 27.6022L30.1905 27.5925L30.1836 29.4844L32.4765 29.4942L32.4834 27.6022ZM32.4913 25.7093L32.4843 27.6013L34.7772 27.611L34.7703 29.5036L37.0631 29.5134L37.0701 27.6208L37.077 25.7288L34.7842 25.7191L32.4913 25.7093ZM32.4913 25.7093L32.4843 27.6013L34.7772 27.611L34.7703 29.5036L37.0631 29.5134L37.0701 27.6208L37.077 25.7288L34.7842 25.7191L32.4913 25.7093Z",
    fill: "#C15900"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M47.9842 26.987H47.9821C48.0099 23.5839 41.6202 20.7645 33.7102 20.69C25.8003 20.6152 19.3655 23.3135 19.338 26.7163C19.3365 26.908 19.3556 27.0977 19.3936 27.2851L19.3634 30.9964C19.3223 31.1917 19.3006 31.3895 19.299 31.5897C19.27 35.1604 25.6498 38.1155 33.5489 38.1903C39.2466 38.2443 44.1783 36.7845 46.4954 34.6267C47.4203 33.7823 47.9431 32.8288 47.9513 31.8165C47.9519 31.753 47.9501 31.6896 47.9464 31.6268L47.9842 26.9874V26.987Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.1225 25.3679C48.1514 21.7972 41.7715 18.8424 33.8724 18.7682C25.9734 18.6939 19.5465 21.5284 19.5176 25.0991C19.4887 28.6698 25.8686 31.6246 33.7677 31.6989C41.6667 31.7731 48.0936 28.9386 48.1225 25.3679Z",
    fill: "#FF7C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M48.1584 20.5401L19.5723 20.2715L19.5317 25.283L48.1178 25.5516L48.1584 20.5401Z",
    fill: "#FF7C00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.5105 20.2715L19.4716 25.1448C19.4716 25.1448 19.2984 28.1279 24.7795 30.1786L24.9974 24.9389C24.9974 24.9389 20.4001 23.1263 19.5108 20.2718L19.5105 20.2715Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 18,
    width: 30,
    height: 14
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M48.078 25.4055C48.1078 21.8348 41.7286 18.8818 33.8296 18.8099C25.9305 18.738 19.5029 21.5743 19.473 25.145C19.4432 28.7157 25.8224 31.6687 33.7214 31.7406C41.6205 31.8125 48.0481 28.9762 48.078 25.4055Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_18",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8266 21.6272L32.4733 21.5957L32.3817 32.8971L35.7351 32.9287L35.8266 21.6272Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_19",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9477 21.545L37.042 21.4707L36.9504 32.7721L44.8561 32.8464L44.9477 21.545Z",
    fill: "white"
  })))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M48.1548 20.5401C48.1824 17.137 41.7925 14.318 33.8826 14.2437C25.9728 14.1694 19.5382 16.8678 19.5106 20.2709C19.483 23.6739 25.8729 26.4929 33.7828 26.5672C41.6926 26.6416 48.1272 23.9431 48.1548 20.5401Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M33.8875 26.2727C26.0685 26.1988 19.7353 23.4429 19.6175 20.0928C19.6132 20.1507 19.6108 20.2089 19.6102 20.2675C19.5824 23.6707 25.9721 26.49 33.8821 26.5646C41.792 26.6394 48.2268 23.9411 48.2543 20.5383C48.2546 20.4992 48.2536 20.4602 48.2524 20.4211C48.0104 23.7413 41.6615 26.3462 33.8875 26.2727Z",
    fill: "url(#paint2_linear_3418_365219)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M43.8938 20.1665C43.9114 17.9927 39.4368 16.1883 33.8994 16.1362C28.362 16.0842 23.8588 17.8042 23.8412 19.978C23.8236 22.1518 28.2982 23.9562 33.8356 24.0083C39.373 24.0603 43.8762 22.3403 43.8938 20.1665Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M33.871 16.1257C39.2663 16.1768 43.652 17.8914 43.8569 19.99C43.8633 19.935 43.8675 19.8797 43.8678 19.8237C43.8856 17.65 39.4111 15.8455 33.8738 15.7932C28.3365 15.7408 23.8332 17.4606 23.8154 19.6343C23.8148 19.69 23.8181 19.7456 23.8235 19.8006C24.0629 17.7063 28.4755 16.0746 33.871 16.1257Z",
    fill: "url(#paint3_linear_3418_365219)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M33.9326 16.6908C39.0979 16.7396 43.3377 18.3133 43.8698 20.2888C43.8731 20.2485 43.8755 20.2081 43.8758 20.1675C43.8937 17.9937 39.4191 16.1893 33.8818 16.1369C28.3445 16.0845 23.8412 17.8043 23.8234 19.9781C23.8222 20.1242 23.8418 20.2683 23.8802 20.4109C24.0609 18.295 28.4986 16.6397 33.9323 16.6911L33.9326 16.6908Z",
    fill: "#CB6300"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M32.7166 17.3682L30.4237 17.3584L30.4167 19.2503L32.7096 19.2601L32.7166 17.3682ZM32.7166 17.3682L30.4237 17.3584L30.4167 19.2503L32.7096 19.2601L32.7166 17.3682ZM32.7027 21.153L30.4098 21.1433L30.4028 23.0352L32.6957 23.045L32.7027 21.153ZM32.7027 21.153L30.4098 21.1433L30.4028 23.0352L32.6957 23.045L32.7027 21.153ZM32.7105 19.2601L32.7036 21.152L34.9964 21.1618L34.9895 23.0544L37.2824 23.0642L37.2893 21.1716L37.2963 19.2796L35.0034 19.2699L32.7105 19.2601ZM32.7105 19.2601L32.7036 21.152L34.9964 21.1618L34.9895 23.0544L37.2824 23.0642L37.2893 21.1716L37.2963 19.2796L35.0034 19.2699L32.7105 19.2601Z",
    fill: "#C15900"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M48.2038 20.5398H48.2017C48.2295 17.1366 41.8398 14.3173 33.9298 14.2427C26.0199 14.1679 19.5851 16.8662 19.5576 20.269C19.5561 20.4607 19.5752 20.6504 19.6132 20.8378L19.583 24.5492C19.5419 24.7444 19.5202 24.9423 19.5187 25.1424C19.4896 28.7131 25.8694 31.6682 33.7685 31.743C39.4662 31.7971 44.398 30.3373 46.715 28.1795C47.64 27.335 48.1627 26.3816 48.1709 25.3692C48.1715 25.3057 48.1697 25.2423 48.166 25.1795L48.2038 20.5401V20.5398Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M51.4806 18.8396C51.5096 15.2689 45.1296 12.3141 37.2306 12.2398C29.3316 12.1656 22.9047 15.0001 22.8758 18.5708C22.8468 22.1415 29.2268 25.0963 37.1258 25.1705C45.0248 25.2448 51.4517 22.4103 51.4806 18.8396Z",
    fill: "#FF7C00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M51.5164 14.0099L22.9303 13.7412L22.8897 18.7527L51.4758 19.0213L51.5164 14.0099Z",
    fill: "#FF7C00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M22.8706 13.7412L22.8317 18.6146C22.8317 18.6146 22.6585 21.5976 28.1396 23.6484L28.3575 18.4086C28.3575 18.4086 23.7602 16.596 22.8709 13.7415L22.8706 13.7412Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 12,
    width: 30,
    height: 14
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M51.438 18.8791C51.4678 15.3084 45.0886 12.3555 37.1896 12.2835C29.2905 12.2116 22.8629 15.0479 22.833 18.6186C22.8031 22.1894 29.1824 25.1423 37.0814 25.2142C44.9805 25.2862 51.4081 22.4498 51.438 18.8791Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_31",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1835 15.0969L35.8301 15.0654L35.7385 26.3669L39.0919 26.3984L39.1835 15.0969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_32",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3049 15.0157L40.3992 14.9414L40.3076 26.2428L48.2133 26.3171L48.3049 15.0157Z",
    fill: "white"
  })))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M51.5115 14.0108C51.5391 10.6077 45.1492 7.78874 37.2393 7.7144C29.3295 7.64006 22.8949 10.3385 22.8673 13.7416C22.8397 17.1446 29.2296 19.9636 37.1395 20.0379C45.0493 20.1123 51.4839 17.4138 51.5115 14.0108Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M37.2463 19.7434C29.4273 19.6695 23.0941 16.9136 22.9762 13.5635C22.972 13.6214 22.9696 13.6796 22.969 13.7382C22.9412 17.1414 29.3309 19.9607 37.2408 20.0353C45.1508 20.1101 51.5855 17.4118 51.613 14.009C51.6133 13.9699 51.6124 13.9309 51.6112 13.8918C51.3692 17.212 45.0202 19.8169 37.2463 19.7434Z",
    fill: "url(#paint4_linear_3418_365219)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M47.2523 13.6372C47.2699 11.4634 42.7953 9.65898 37.2579 9.60694C31.7206 9.5549 27.2174 11.2749 27.1997 13.4487C27.1821 15.6225 31.6568 17.427 37.1941 17.479C42.7315 17.531 47.2347 15.811 47.2523 13.6372Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M37.227 9.59643C42.6223 9.64752 47.008 11.3621 47.2129 13.4607C47.2192 13.4057 47.2234 13.3504 47.2237 13.2944C47.2416 11.1207 42.767 9.31625 37.2297 9.26386C31.6924 9.21147 27.1892 10.9313 27.1713 13.105C27.1707 13.1607 27.1741 13.2163 27.1795 13.2713C27.4188 11.177 31.8314 9.54534 37.227 9.59643Z",
    fill: "url(#paint5_linear_3418_365219)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M37.2933 10.1605C42.4586 10.2093 46.6984 11.783 47.2305 13.7586C47.2338 13.7182 47.2362 13.6779 47.2365 13.6372C47.2544 11.4634 42.7798 9.65903 37.2425 9.60663C31.7052 9.55424 27.202 11.274 27.1841 13.4478C27.1829 13.5939 27.2026 13.7381 27.2409 13.8806C27.4216 11.7648 31.8593 10.1094 37.293 10.1608L37.2933 10.1605Z",
    fill: "#CB6300"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M36.0765 10.8418L33.7837 10.832L33.7767 12.724L36.0696 12.7337L36.0765 10.8418ZM36.0765 10.8418L33.7837 10.832L33.7767 12.724L36.0696 12.7337L36.0765 10.8418ZM36.0626 14.6267L33.7698 14.6169L33.7628 16.5088L36.0557 16.5186L36.0626 14.6267ZM36.0626 14.6267L33.7698 14.6169L33.7628 16.5088L36.0557 16.5186L36.0626 14.6267ZM36.0705 12.7337L36.0636 14.6257L38.3564 14.6354L38.3495 16.528L40.6424 16.5378L40.6493 14.6452L40.6563 12.7533L38.3634 12.7435L36.0705 12.7337ZM36.0705 12.7337L36.0636 14.6257L38.3564 14.6354L38.3495 16.528L40.6424 16.5378L40.6493 14.6452L40.6563 12.7533L38.3634 12.7435L36.0705 12.7337Z",
    fill: "#C15900"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M51.5634 14.0134H51.5613C51.5891 10.6102 45.1994 7.79088 37.2894 7.71636C29.3795 7.64152 22.9447 10.3398 22.9173 13.7427C22.9157 13.9343 22.9348 14.124 22.9729 14.3115L22.9426 18.0228C22.9015 18.218 22.8798 18.4159 22.8783 18.616C22.8493 22.1868 29.229 25.1418 37.1281 25.2167C42.8258 25.2707 47.7576 23.8109 50.0746 21.6531C50.9996 20.8086 51.5223 19.8552 51.5305 18.8428C51.5311 18.7794 51.5293 18.7159 51.5256 18.6531L51.5634 14.0137V14.0134Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M49.071 12.5554C49.0999 8.98471 42.7199 6.0299 34.8209 5.95566C26.9219 5.88142 20.495 8.71588 20.4661 12.2866C20.4372 15.8573 26.8171 18.8121 34.7161 18.8864C42.6152 18.9606 49.042 16.1261 49.071 12.5554Z",
    fill: "#FF7C00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M49.1054 7.72471L20.5193 7.45605L20.4787 12.4675L49.0648 12.7362L49.1054 7.72471Z",
    fill: "#FF7C00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M20.4596 7.45605L20.4207 12.3294C20.4207 12.3294 20.2475 15.3125 25.7286 17.3632L25.9465 12.1234C25.9465 12.1234 21.3492 10.3109 20.4599 7.45638L20.4596 7.45605Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 5,
    width: 30,
    height: 14
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M49.0254 12.5862C49.0552 9.01545 42.676 6.06251 34.777 5.99058C26.8779 5.91865 20.4503 8.75497 20.4204 12.3257C20.3905 15.8964 26.7698 18.8493 34.6688 18.9213C42.5679 18.9932 48.9955 16.1569 49.0254 12.5862Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_44",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7717 8.80691L33.4183 8.77539L33.3268 20.0768L36.6801 20.1083L36.7717 8.80691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_45",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8938 8.72664L37.988 8.65234L37.8965 19.9538L45.8022 20.0281L45.8938 8.72664Z",
    fill: "white"
  })))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M49.1005 7.72463C49.1281 4.32158 42.7382 1.50261 34.8283 1.42827C26.9185 1.35393 20.4839 4.05238 20.4563 7.45543C20.4287 10.8585 26.8186 13.6774 34.7285 13.7518C42.6383 13.8261 49.0729 11.1277 49.1005 7.72463Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M34.8342 13.4563C27.0152 13.3824 20.682 10.6265 20.5641 7.27637C20.5599 7.33429 20.5575 7.39254 20.5569 7.45111C20.5291 10.8543 26.9188 13.6736 34.8287 13.7482C42.7387 13.823 49.1734 11.1247 49.2009 7.72186C49.2012 7.68281 49.2003 7.64376 49.1991 7.60471C48.9571 10.9249 42.6081 13.5298 34.8342 13.4563Z",
    fill: "url(#paint6_linear_3418_365219)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M44.8427 7.35008C44.8604 5.17627 40.3857 3.37187 34.8484 3.31983C29.311 3.26779 24.8078 4.98782 24.7902 7.16163C24.7726 9.33543 29.2472 11.1398 34.7846 11.1919C40.3219 11.2439 44.8251 9.52389 44.8427 7.35008Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M34.8179 3.31225C40.2132 3.36334 44.5989 5.07794 44.8038 7.17652C44.8102 7.12152 44.8144 7.0662 44.8147 7.01023C44.8325 4.83648 40.358 3.03207 34.8207 2.97968C29.2834 2.92729 24.7801 4.64709 24.7623 6.82084C24.7617 6.87649 24.765 6.93213 24.7704 6.98713C25.0098 4.89278 29.4224 3.26116 34.8179 3.31225Z",
    fill: "url(#paint7_linear_3418_365219)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M34.882 3.87435C40.0474 3.92316 44.2871 5.49685 44.8192 7.47243C44.8226 7.43208 44.825 7.39173 44.8253 7.35105C44.8431 5.1773 40.3686 3.37289 34.8313 3.3205C29.294 3.26811 24.7907 4.98791 24.7729 7.16166C24.7717 7.30777 24.7913 7.45193 24.8297 7.59446C25.0104 5.47863 29.4481 3.82326 34.8817 3.87468L34.882 3.87435Z",
    fill: "#CB6300"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M33.7235 4.38867L30.9819 4.37695L30.975 6.2689L33.7166 6.28061L33.7235 4.38867ZM33.7235 4.38867L30.9819 4.37695L30.975 6.2689L33.7166 6.28061L33.7235 4.38867ZM33.7096 8.17353L30.968 8.16182L30.9611 10.0538L33.7027 10.0655L33.7096 8.17353ZM33.7096 8.17353L30.968 8.16182L30.9611 10.0538L33.7027 10.0655L33.7096 8.17353ZM33.7178 6.28061L33.7108 8.17255L36.4524 8.18427L36.4455 10.0769L39.1871 10.0886L39.194 8.19598L39.201 6.30404L36.4594 6.29233L33.7178 6.28061ZM33.7178 6.28061L33.7108 8.17255L36.4524 8.18427L36.4455 10.0769L39.1871 10.0886L39.194 8.19598L39.201 6.30404L36.4594 6.29233L33.7178 6.28061Z",
    fill: "#C15900"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M49.153 7.72727H49.1509C49.1787 4.32412 42.789 1.50475 34.879 1.43023C26.9691 1.35539 20.5344 4.0537 20.5069 7.45653C20.5053 7.64819 20.5244 7.83791 20.5625 8.02535L20.5322 11.7367C20.4911 11.9319 20.4694 12.1298 20.4679 12.3299C20.4389 15.9006 26.8186 18.8557 34.7177 18.9305C40.4154 18.9846 45.3472 17.5248 47.6642 15.367C48.5892 14.5225 49.1119 13.5691 49.1201 12.5567C49.1207 12.4932 49.1189 12.4298 49.1152 12.367L49.153 7.7276V7.72727Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M33.4632 38.0906C33.4921 34.5199 27.1122 31.5651 19.2131 31.4908C11.3141 31.4166 4.88724 34.251 4.8583 37.8218C4.82937 41.3925 11.2093 44.3473 19.1084 44.4215C27.0074 44.4958 33.4343 41.6613 33.4632 38.0906Z",
    fill: "#FF7C00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M33.4981 33.2618L4.91199 32.9932L4.87138 38.0046L33.4575 38.2733L33.4981 33.2618Z",
    fill: "#FF7C00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M4.84941 32.9932L4.81043 37.8665C4.81043 37.8665 4.63728 40.8496 10.1184 42.9003L10.3362 37.6605C10.3362 37.6605 5.739 35.848 4.84971 32.9935L4.84941 32.9932Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 31,
    width: 30,
    height: 14
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M33.4158 38.1223C33.4456 34.5516 27.0664 31.5986 19.1673 31.5267C11.2683 31.4548 4.84065 34.2911 4.81079 37.8618C4.78092 41.4325 11.1602 44.3855 19.0592 44.4574C26.9582 44.5293 33.3859 41.693 33.4158 38.1223Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_57",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1654 34.344L17.812 34.3125L17.7204 45.6139L21.0738 45.6455L21.1654 34.344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_58",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2863 34.2638L22.3806 34.1895L22.289 45.4909L30.1947 45.5652L30.2863 34.2638Z",
    fill: "white"
  })))))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M33.4937 33.2608C33.5212 29.8577 27.1314 27.0387 19.2215 26.9644C11.3116 26.8901 4.87707 29.5885 4.84949 32.9916C4.82192 36.3946 11.2118 39.2136 19.1216 39.2879C27.0315 39.3623 33.4661 36.6638 33.4937 33.2608Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M19.2264 38.9953C11.4074 38.9215 5.07416 36.1655 4.95632 32.8154C4.95209 32.8734 4.94967 32.9316 4.94906 32.9902C4.92127 36.3933 11.311 39.2127 19.2209 39.2872C27.1309 39.3621 33.5656 36.6637 33.5931 33.2609C33.5934 33.2219 33.5925 33.1828 33.5913 33.1438C33.3493 36.4639 27.0003 39.0689 19.2264 38.9953Z",
    fill: "url(#paint8_linear_3418_365219)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M29.234 32.8872C29.2516 30.7134 24.777 28.909 19.2396 28.8569C13.7022 28.8049 9.19905 30.5249 9.18143 32.6987C9.16382 34.8725 13.6385 36.677 19.1758 36.729C24.7132 36.781 29.2164 35.061 29.234 32.8872Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M19.2082 28.8503C24.6035 28.9014 28.9892 30.616 29.1941 32.7146C29.2004 32.6596 29.2046 32.6043 29.2049 32.5483C29.2228 30.3746 24.7482 28.5702 19.2109 28.5178C13.6736 28.4654 9.17036 30.1852 9.15254 32.3589C9.15193 32.4146 9.15526 32.4702 9.16069 32.5252C9.40001 30.4309 13.8126 28.7992 19.2082 28.8503Z",
    fill: "url(#paint9_linear_3418_365219)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M19.2713 29.4124C24.4366 29.4613 28.6764 31.0349 29.2085 33.0105C29.2118 32.9702 29.2143 32.9298 29.2146 32.8891C29.2324 30.7154 24.7578 28.911 19.2205 28.8586C13.6833 28.8062 9.17999 30.526 9.16216 32.6997C9.16095 32.8459 9.18059 32.99 9.21897 33.1325C9.39967 31.0167 13.8374 29.3613 19.271 29.4128L19.2713 29.4124Z",
    fill: "#CB6300"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M18.1156 29.9248L15.374 29.9131L15.367 31.805L18.1087 31.8167L18.1156 29.9248ZM18.1156 29.9248L15.374 29.9131L15.367 31.805L18.1087 31.8167L18.1156 29.9248ZM18.1017 33.7097L15.3601 33.6979L15.3531 35.5899L18.0948 35.6016L18.1017 33.7097ZM18.1017 33.7097L15.3601 33.6979L15.3531 35.5899L18.0948 35.6016L18.1017 33.7097ZM18.1099 31.8167L18.1029 33.7087L20.8445 33.7204L20.8376 35.613L23.5792 35.6247L23.5861 33.7321L23.5931 31.8402L20.8515 31.8285L18.1099 31.8167ZM18.1099 31.8167L18.1029 33.7087L20.8445 33.7204L20.8376 35.613L23.5792 35.6247L23.5861 33.7321L23.5931 31.8402L20.8515 31.8285L18.1099 31.8167Z",
    fill: "#C15900"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M33.5451 33.2634H33.543C33.5708 29.8602 27.1811 27.0409 19.2711 26.9664C11.3612 26.8918 4.92644 29.5898 4.89894 32.9926C4.89743 33.1843 4.91647 33.374 4.95454 33.5615L4.92432 37.2728C4.88323 37.468 4.86147 37.6659 4.85996 37.866C4.83095 41.4368 11.2107 44.3918 19.1098 44.4667C24.8075 44.5207 29.7393 43.0609 32.0563 40.9031C32.9813 40.0586 33.504 39.1052 33.5122 38.0928C33.5128 38.0294 33.511 37.9659 33.5073 37.9031L33.5451 33.2637V33.2634Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M29.2477 31.6572C29.2768 28.0865 22.897 25.1321 14.998 25.0583C7.09897 24.9846 0.671938 27.8194 0.642816 31.3901C0.613695 34.9608 6.99351 37.9153 14.8925 37.989C22.7916 38.0628 29.2186 35.228 29.2477 31.6572Z",
    fill: "#FF7C00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M29.2839 26.8292L0.697754 26.5605L0.657143 31.572L29.2433 31.8407L29.2839 26.8292Z",
    fill: "#FF7C00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M0.635783 26.5596L0.596803 31.4329C0.596803 31.4329 0.423659 34.416 5.90475 36.4667L6.12261 31.2269C6.12261 31.2269 1.52538 29.4144 0.636085 26.5599L0.635783 26.5596Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 25,
    width: 30,
    height: 14
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M29.2041 31.6946C29.2339 28.1238 22.8547 25.1709 14.9557 25.099C7.05663 25.027 0.628979 27.8634 0.599116 31.4341C0.569253 35.0048 6.94848 37.9577 14.8475 38.0297C22.7466 38.1016 29.1742 35.2653 29.2041 31.6946Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_70",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9524 27.9143L13.599 27.8828L13.5074 39.1843L16.8608 39.2158L16.9524 27.9143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_71",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0727 27.8341L18.167 27.7598L18.0754 39.0612L25.9811 39.1355L26.0727 27.8341Z",
    fill: "white"
  })))))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M29.2787 26.8281C29.3063 23.4251 22.9164 20.6061 15.0065 20.5318C7.09668 20.4574 0.662104 23.1559 0.634527 26.5589C0.60695 29.962 6.99681 32.781 14.9067 32.8553C22.8165 32.9296 29.2511 30.2312 29.2787 26.8281Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M15.0115 32.5617C7.19253 32.4879 0.85932 29.7319 0.741473 26.3818C0.737243 26.4398 0.734826 26.498 0.734221 26.5566C0.706421 29.9597 7.09614 32.7791 15.0061 32.8536C22.916 32.9285 29.3508 30.2302 29.3783 26.8273C29.3786 26.7883 29.3777 26.7492 29.3765 26.7102C29.1344 30.0304 22.7855 32.6353 15.0115 32.5617Z",
    fill: "url(#paint10_linear_3418_365219)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M25.0196 26.4546C25.0372 24.2808 20.5626 22.4764 15.0252 22.4243C9.48789 22.3723 4.98469 24.0923 4.96708 26.2661C4.94946 28.4399 9.4241 30.2443 14.9615 30.2964C20.4988 30.3484 25.002 28.6284 25.0196 26.4546Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M14.9948 22.4148C20.3901 22.4659 24.7758 24.1805 24.9807 26.2791C24.987 26.2241 24.9913 26.1687 24.9916 26.1128C25.0094 23.939 20.5348 22.1346 14.9975 22.0822C9.46025 22.0298 4.95699 23.7496 4.93916 25.9234C4.93855 25.979 4.94188 26.0347 4.94732 26.0897C5.18664 23.9953 9.59925 22.3637 14.9948 22.4148Z",
    fill: "url(#paint11_linear_3418_365219)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M15.0571 22.9788C20.2224 23.0277 24.4622 24.6013 24.9943 26.5769C24.9976 26.5366 25 26.4962 25.0003 26.4555C25.0182 24.2818 20.5436 22.4774 15.0063 22.425C9.46902 22.3726 4.96576 24.0924 4.94793 26.2662C4.94672 26.4123 4.96636 26.5564 5.00474 26.699C5.18544 24.5831 9.62313 22.9278 15.0568 22.9792L15.0571 22.9788Z",
    fill: "#CB6300"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M13.9003 23.4951L11.1587 23.4834L11.1517 25.3753L13.8933 25.3871L13.9003 23.4951ZM13.9003 23.4951L11.1587 23.4834L11.1517 25.3753L13.8933 25.3871L13.9003 23.4951ZM13.8864 27.28L11.1448 27.2683L11.1378 29.1602L13.8794 29.1719L13.8864 27.28ZM13.8864 27.28L11.1448 27.2683L11.1378 29.1602L13.8794 29.1719L13.8864 27.28ZM13.8945 25.3871L13.8876 27.279L16.6292 27.2907L16.6222 29.1833L19.3638 29.195L19.3708 27.3024L19.3777 25.4105L16.6361 25.3988L13.8945 25.3871ZM13.8945 25.3871L13.8876 27.279L16.6292 27.2907L16.6222 29.1833L19.3638 29.195L19.3708 27.3024L19.3777 25.4105L16.6361 25.3988L13.8945 25.3871Z",
    fill: "#C15900"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M29.3294 26.8298H29.3273C29.3551 23.4267 22.9654 20.6073 15.0554 20.5328C7.14549 20.4579 0.710741 23.1562 0.683244 26.5591C0.681733 26.7507 0.70077 26.9404 0.738843 27.1279L0.708626 30.8392C0.667531 31.0345 0.645774 31.2323 0.644264 31.4324C0.615255 35.0032 6.995 37.9582 14.8941 38.0331C20.5918 38.0871 25.5236 36.6273 27.8406 34.4695C28.7656 33.6251 29.2883 32.6716 29.2965 31.6592C29.2971 31.5958 29.2953 31.5323 29.2916 31.4695L29.3294 26.8301V26.8298Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M26.8416 15.3321C26.8416 12.6568 26.656 12.457 24.1719 12.457C26.656 12.457 26.8416 12.2572 26.8416 9.58203C26.8416 12.2572 27.0271 12.457 29.5112 12.457C27.0271 12.457 26.8416 12.6568 26.8416 15.3321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M54.9009 40.9411C53.6699 41.0507 52.4391 41.1604 51.2084 41.2704C48.2634 41.5327 45.2103 39.9456 43.0174 36.604C39.2871 30.919 39.4591 22.3083 43.4012 17.3718C45.0263 15.3367 47.0378 14.2436 49.1029 14.0598L52.7957 13.7305C50.7307 13.9147 48.7188 15.0074 47.0937 17.0425C43.1513 21.98 42.9797 30.59 46.71 36.275C48.9028 39.617 51.9557 41.204 54.9009 40.9411Z",
    fill: "#FF7C00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M60.6042 37.6288C56.6614 42.566 50.4418 41.9594 46.7115 36.2745C42.9812 30.5899 43.1528 21.9795 47.0953 17.042C51.0377 12.1052 57.2579 12.7114 60.9879 18.3964C64.7185 24.0813 64.5463 32.692 60.6042 37.6288Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M58.8184 34.5713C55.9861 38.118 51.5179 37.6839 48.8368 33.5984C46.1571 29.5148 46.2804 23.3274 49.1126 19.7807C51.9458 16.2328 56.4143 16.6698 59.094 20.7534C61.7748 24.8393 61.6513 31.0231 58.8184 34.5713Z",
    fill: "url(#paint12_linear_3418_365219)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M58.7023 34.7305C55.87 38.2771 51.4015 37.8437 48.7206 33.7578C46.0413 29.6739 46.1643 23.4865 48.9968 19.9399C51.83 16.3919 56.2982 16.8289 58.9779 20.9132C61.659 24.9984 61.5351 31.1828 58.7026 34.7308L58.7023 34.7305Z",
    fill: "#FF9600"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M58.0428 21.4085C60.7237 25.4941 60.6001 31.6782 57.7669 35.2265C57.2684 35.8506 56.7181 36.3491 56.1367 36.7286C57.065 36.3436 57.9416 35.682 58.701 34.7315C61.5338 31.1835 61.6574 24.9994 58.9762 20.9139C56.7683 17.5485 53.3468 16.6624 50.6251 18.4388C53.1606 17.3868 56.0805 18.4193 58.0425 21.4088L58.0428 21.4085Z",
    fill: "#CB6300"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M52.523 21.0928L49.8416 21.2578L50.0304 24.8145L52.7119 24.6495L52.523 21.0928ZM52.523 21.0928L49.8416 21.2578L50.0304 24.8145L52.7119 24.6495L52.523 21.0928ZM52.9007 28.2079L50.2193 28.3729L50.4081 31.9296L53.0896 31.7646L52.9007 28.2079ZM52.9007 28.2079L50.2193 28.3729L50.4081 31.9296L53.0896 31.7646L52.9007 28.2079ZM52.7128 24.6492L52.9016 28.2059L55.5831 28.041L55.772 31.599L58.4534 31.434L58.2646 27.876L58.0757 24.3192L55.3943 24.4842L52.7128 24.6492ZM52.7128 24.6492L52.9016 28.2059L55.5831 28.041L55.772 31.599L58.4534 31.434L58.2646 27.876L58.0757 24.3192L55.3943 24.4842L52.7128 24.6492Z",
    fill: "#C15900"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M46.513 36.2903C48.7337 39.6736 51.8355 41.2574 54.8143 40.945C51.8959 41.1695 48.8809 39.5838 46.7095 36.2743C42.9792 30.5897 43.1508 21.9793 47.0932 17.0419C48.6926 15.039 50.667 13.9508 52.6979 13.7412C52.6544 13.7448 52.6115 13.7461 52.5683 13.7497L52.484 13.7575C50.4597 13.9713 48.492 15.0604 46.8974 17.0578C42.9547 21.995 42.783 30.605 46.5134 36.2903H46.513Z",
    fill: "url(#paint13_linear_3418_365219)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3418_365219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 15,
    height: 29
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M53.0528 13.7256C51.82 13.8089 50.5877 13.8925 49.3548 13.9755C46.4057 14.1753 43.5982 16.2218 41.8776 19.87C38.9508 26.0766 40.2791 34.5698 44.8434 38.8399C46.725 40.6 48.8623 41.368 50.9304 41.2277L54.6283 40.9778C52.5603 41.1174 50.4227 40.3501 48.5411 38.59C43.9762 34.3196 42.6488 25.8267 45.5753 19.6201C47.2955 15.9713 50.103 13.9251 53.0525 13.7256H53.0528Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3418_365219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_88",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9506 22.2192L36.0315 23.5732L36.5657 31.3149L53.4848 29.9609L52.9506 22.2192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_89",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1014 17.4399L36.1824 18.7939L36.4181 22.2101L53.3372 20.8561L53.1014 17.4399Z",
    fill: "white"
  }))))))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M51.2649 41.1709C52.4827 41.0619 53.7004 40.9535 54.9182 40.8448C56.9599 40.6743 58.9521 39.6157 60.5721 37.6372C60.6014 37.6017 60.6304 37.5656 60.6591 37.5295C60.696 37.4833 60.7325 37.4368 60.7688 37.3899C60.7791 37.3769 60.789 37.3635 60.7993 37.3502C60.8286 37.3121 60.8573 37.2737 60.8863 37.2353C60.8933 37.2262 60.9002 37.2171 60.9069 37.2077C64.5692 32.2767 64.6916 24.0314 61.1538 18.4689C61.1526 18.4669 61.1513 18.4649 61.1501 18.4633C61.1148 18.4077 61.0791 18.3524 61.0429 18.297C61 18.2316 60.9564 18.1669 60.9129 18.1028C60.9054 18.0917 60.8978 18.0803 60.89 18.0692C60.8456 18.0045 60.8011 17.9404 60.7561 17.8773C60.754 17.8743 60.7519 17.8714 60.7498 17.8681C58.9736 15.3696 56.6952 13.9518 54.3806 13.6596L54.3791 13.6127C53.8687 13.5636 53.3574 13.5701 52.8498 13.631L52.6428 13.6495C52.6371 13.6498 52.631 13.6502 52.6253 13.6508L52.541 13.6586C52.5383 13.6586 52.5358 13.6593 52.5331 13.6596L49.1594 13.9606C47.7198 14.0888 46.3063 14.6593 45.0314 15.6824C45.0302 15.6833 45.0293 15.684 45.0281 15.685C44.9749 15.7276 44.9217 15.7712 44.8691 15.8154C44.8643 15.8197 44.8592 15.8239 44.8543 15.8281C44.8054 15.8695 44.7564 15.9114 44.7078 15.9544C44.699 15.9619 44.6906 15.97 44.6818 15.9775C44.6368 16.0175 44.5917 16.0579 44.547 16.0989C44.5346 16.1103 44.5225 16.122 44.5102 16.1334C44.4691 16.1718 44.428 16.2102 44.3872 16.2492C44.3715 16.2642 44.3561 16.2798 44.3403 16.2951C44.3032 16.3315 44.2657 16.368 44.2288 16.4051C44.2098 16.4243 44.1908 16.4441 44.172 16.4633C44.1385 16.4975 44.1049 16.5317 44.0717 16.5668C44.049 16.5906 44.0267 16.615 44.0043 16.6391C43.9747 16.6706 43.9451 16.7022 43.9158 16.7344C43.8895 16.7634 43.8632 16.7933 43.8369 16.8229C43.8118 16.8512 43.7865 16.8792 43.7614 16.9079C43.7294 16.9446 43.6976 16.9824 43.6659 17.0198C43.6469 17.0422 43.6275 17.0644 43.6088 17.0872C43.558 17.148 43.5079 17.2095 43.4577 17.2723C39.5156 22.2088 39.3433 30.8198 43.0739 36.5045C45.2668 39.8461 48.3199 41.4331 51.2649 41.1709ZM52.8483 13.6313C52.8468 13.6313 52.8453 13.6316 52.8437 13.6319C52.8407 13.6319 52.8377 13.6326 52.8347 13.6329C52.8392 13.6326 52.8437 13.6319 52.8483 13.6316V13.6313Z",
    stroke: "#771B00",
    strokeWidth: 1.20566,
    strokeMiterlimit: 10
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_365219",
    x1: 19.3674,
    y1: 29.706,
    x2: 48.0119,
    y2: 29.9382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_365219",
    x1: 23.6105,
    y1: 24.1965,
    x2: 43.6632,
    y2: 24.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_365219",
    x1: 19.5869,
    y1: 23.2599,
    x2: 48.2314,
    y2: 23.4921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3418_365219",
    x1: 23.8315,
    y1: 17.7481,
    x2: 43.8842,
    y2: 17.9106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3418_365219",
    x1: 22.9455,
    y1: 16.7307,
    x2: 51.59,
    y2: 16.9628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3418_365219",
    x1: 27.1873,
    y1: 11.2189,
    x2: 47.24,
    y2: 11.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3418_365219",
    x1: 20.5332,
    y1: 10.4435,
    x2: 49.1774,
    y2: 10.6756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3418_365219",
    x1: 24.778,
    y1: 4.93463,
    x2: 44.8305,
    y2: 5.09713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3418_365219",
    x1: 4.92639,
    y1: 35.9833,
    x2: 33.5709,
    y2: 36.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3418_365219",
    x1: 9.16954,
    y1: 30.4738,
    x2: 29.2223,
    y2: 30.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3418_365219",
    x1: 0.711234,
    y1: 29.5502,
    x2: 29.3557,
    y2: 29.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3418_365219",
    x1: 4.95585,
    y1: 24.0384,
    x2: 25.0086,
    y2: 24.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3418_365219",
    x1: 49.5409,
    y1: 18.0112,
    x2: 59.2813,
    y2: 35.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3418_365219",
    x1: 47.5814,
    y1: 15.6452,
    x2: 51.5172,
    y2: 42.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperCoinStack);
export default __webpack_public_path__ + "static/media/hyper-coin-stack.4d0c012fe57d4430b49f54bf5f8cb0ab.svg";
export { ForwardRef as ReactComponent };